"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _orderRefund = require("@/api/orderRefund");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['refundId'],
  data: function data() {
    return {
      dialogVisible: false,
      formLabelWidth: "120px",
      form: {
        refuse_reason: ""
      }
    };
  },
  methods: {
    close: function close() {
      this.dialogVisible = false;
      this.form = {
        refuse_reason: ""
      };
    },
    submit_refuse: function submit_refuse() {
      var _this = this;

      if (!this.form.refuse_reason) {
        this.$message.warning('拒绝原因不能为空');
        return false;
      }

      var obj = {
        refund_id: this.refundId,
        refuse_reason: this.form.refuse_reason
      };
      (0, _orderRefund.adminCheckRefuse)(obj).then(function (res) {
        _this.close();

        _this.$parent.getList();
      });
    }
  },
  mounted: function mounted() {}
};
exports.default = _default;